module.exports = __webpack_public_path__ + "static/img/anxun84.de1513bc.png";